import { useTheme } from '@emotion/react';

import { type MOOD_STATES, MOODS } from '../constants';
import * as styles from '../MoodBox.styles';
import { faceIllustrationColorMap } from '../MoodBox.styles';

type NegativeMoodProps = {
  state: MOOD_STATES;
};

export const NegativeMood = ({ state }: NegativeMoodProps) => {
  const theme = useTheme();

  const color = faceIllustrationColorMap(MOODS.NEGATIVE, state, theme);

  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={styles.negativeMood}
    >
      <path
        d="M11.3224 6.36929C10.269 5.433 8.92283 4.86618 7.30012 4.86618C5.6774 4.86618 4.3312 5.433 3.27788 6.36929C2.6442 6.93256 2.23989 7.50336 2.0268 7.92952C1.73042 8.5223 1.97069 9.24311 2.56346 9.53949C3.15623 9.83588 3.87704 9.59561 4.17343 9.00284L4.21963 8.91926C4.32994 8.73479 4.54765 8.4517 4.87235 8.16307C5.50653 7.59936 6.29783 7.26618 7.30012 7.26618C8.3024 7.26618 9.0937 7.59936 9.72788 8.16307C10.1067 8.49981 10.3399 8.82901 10.4268 9.00284L10.4966 9.1244C10.8255 9.6272 11.4863 9.81471 12.0368 9.53949C12.6295 9.24311 12.8698 8.5223 12.5734 7.92952C12.3603 7.50336 11.956 6.93256 11.3224 6.36929Z"
        fill={color}
      />
      <path
        d="M10.8368 0.192869L10.708 0.137504C10.1432 -0.0673963 9.50202 0.179092 9.2268 0.729525C8.93042 1.3223 9.17069 2.04311 9.76346 2.33949L12.1635 3.53949L12.2922 3.59486C12.857 3.79976 13.4982 3.55327 13.7734 3.00284C14.0698 2.41006 13.8295 1.68926 13.2368 1.39287L10.8368 0.192869Z"
        fill={color}
      />
      <path
        d="M4.35833 2.26969C4.86113 1.94079 5.04865 1.27996 4.77343 0.729525C4.47704 0.136751 3.75623 -0.103518 3.16346 0.192869L0.76346 1.39287L0.6419 1.46267C0.1391 1.79157 -0.0484128 2.4524 0.226804 3.00284C0.523191 3.59561 1.244 3.83588 1.83677 3.53949L4.23677 2.33949L4.35833 2.26969Z"
        fill={color}
      />
    </svg>
  );
};
